// Imports.
import $ from "jquery";
import "./cookie.js";
import "slick-carousel";
import "lity";
import "./lity_lightbox.js";
import "bootstrap";
import Headroom from "headroom.js";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";
import "./../../modules/gutenberg_hero/GutenbergHero.js";
import "./../../modules/hoas_list_all_schools/hoas_list_all_schools.js";
import "./notification-banner.js";
import "./restrict_menu_tabbing_mobilemenu.js";
import "./chat_buttons.js";
import Isotope from "isotope-layout";
import property_select_and_compare from "./property_select_and_compare.js";
import accessibility from "./accessibility.js";
import primaryNavigation from "./primary-navigation.js";
import initializeModals from "./initializeModal.js";
import { initializeCostUnitApartmentsListing } from "./costUnitApartmentsListing.js";
import { mobileHeaderFavouritesCounter } from "./hoasFavouritesDom.js";
// FOCUS TRAP FOR ACCESSIBILITY TABBING
import * as focusTrap from "focus-trap";
import { initScrollVeil } from "./scroll-veil.js";

const searchTrapElement = document.getElementById("hoasSearchModal");
const mobileModalTrapElement = document.getElementById("hoasMobileModal");
const primaryNavigationModal = document.getElementById(
  "hoasPrimaryNavigationModal",
);

const superTrap = focusTrap.createFocusTrap("body", {
  onActivate: () => document.body.classList.add("is-active"),
  onDeactivate: () => document.body.classList.remove("is-active"),
});

const searchTrap = focusTrap.createFocusTrap("#hoasSearchModal", {
  onActivate: () => searchTrapElement.classList.add("is-active"),
  onDeactivate: () => searchTrapElement.classList.remove("is-active"),
});

const mobileModalTrap = focusTrap.createFocusTrap("#hoasMobileModal", {
  onActivate: () => mobileModalTrapElement.classList.add("is-active"),
  onDeactivate: () => mobileModalTrapElement.classList.remove("is-active"),
  fallbackFocus: "#hoasMobileModal",
});

const primaryNavigationTrap = focusTrap.createFocusTrap(
  "#hoasPrimaryNavigationModal",
  {
    onActivate: () => primaryNavigationModal.classList.add("is-active"),
    onDeactivate: () => primaryNavigationModal.classList.remove("is-active"),
  },
);

//Assing necessary functions and variables to hoas-gravityforms-plugin
const { globalAccessibilitySpeakerId, announceMessage } = accessibility();

const hoasApp = (function () {
  // Initialize Hoas favourites
  window.hoasFavourites.initializeFavouritesDOM();

  // Page load actions.
  const ww = window.innerWidth;
  const mobileMaxWidth = 1200; // Width when we change from mobile menu to desktop
  // eslint-disable-next-line no-unused-vars
  let isMobile = ww < mobileMaxWidth;
  const primaryNavEl = document.getElementById("hoas-header");

  // Start calculcating the offset from site-container, since the notification is before it, and otherwise affects the distance.
  const headroomOffset =
    document.querySelector("#site-container").offsetTop +
    primaryNavEl.offsetHeight; //window.innerHeight / 2;
  const modalTriggers = document.querySelectorAll("[data-target]");
  const applicationModals = $(".hoas-application-popup");
  const body = document.body;
  // Back to top button on top of the footer (functionality below init function)
  const backToTopButton = document.getElementById("button-back-to-top");
  let cookiebotWidget = null;
  let checkCbTimeout;

  const propertyCompareSelectWrappers = document.querySelectorAll(
    "[data-property-selector-wrapper]",
  );
  propertyCompareSelectWrappers.forEach((wrapper) =>
    property_select_and_compare(wrapper),
  );

  const { initialize, handleApplicationModals, handleModalTriggers } =
    initializeModals();
  const { handlePrimaryNavigation, navigationMenuActions } =
    primaryNavigation();

  const init = () => {
    $(window).on("keydown", handleFirstTab);

    $(window).on("click", function (e) {
      body.classList.remove("user-is-tabbing");
    });

    stickyNav();
    navigationMenuActions();
    listenForAreaSuggestionsResults();

    navigationModalInit();
    mobileMenuModalInit();
    searchModalInit();

    //OnInit check window width
    resize();

    document.addEventListener("click", handlePrimaryNavigation);
    document.addEventListener("keydown", handlePrimaryNavigation);

    if (modalTriggers.length) {
      handleModalTriggers(modalTriggers);
    }

    if (applicationModals.length) {
      handleApplicationModals(applicationModals);
    }

    initializeCostUnitApartmentsListing();
  };

  const checkElement = (observer) => {
    //For area-suggestor page --> handle card buttons with observer
    //finished class is added after cards have been queried and constructed in the dom
    const element = $("#area-suggestions-results--list.finished");
    if (element.length > 0) {
      window.hoasFavourites.initializeFavouritesDOM();
      observer.disconnect(); // Stop observing once the element is found
    }
  };

  const listenForAreaSuggestionsResults = () => {
    const observer = new MutationObserver(() => checkElement(observer));
    const config = { childList: true, subtree: true };
    observer.observe(document.body, config);
    checkElement(observer);
  };

  const moveCookieBotModal = (modalId = "", addToModal = false) => {
    const modal = document.getElementById(modalId);
    const cookiebot = document.getElementById("CookiebotWidget");

    if (!modal || !cookiebot) {
      return;
    }

    if (!cookiebot.classList.contains("CookiebotWidget-open")) {
      // Not active --> Return early
      return;
    }

    if (addToModal) {
      // Already in modal --> Move to body
      modal.appendChild(cookiebot);
      return;
    }
    document.body.appendChild(cookiebot);
  };

  /**
   * Trigger primary navigation close by clicking the close button,
   * when clicking outside of the modal or pressing escape
   * @param {Event} e
   * @returns {Event}
   */
  const triggerClosePrimaryNavigation = (e) => {
    const modalId = "#hoasPrimaryNavigationModal";
    const closeButton = document.querySelector(modalId + " .close-navigation");

    if (!$(modalId)?.data("ready") || !closeButton) {
      return e;
    }

    closeButton.click();
    return e;
  };

  const closePrimaryNavigation = () => {
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape" && e.key !== "Esc") {
        return;
      }
      triggerClosePrimaryNavigation(e);
    });

    document.addEventListener("mousedown", (e) => {
      if (!e.target.classList.contains("modal-backdrop")) {
        return e;
      }
      triggerClosePrimaryNavigation(e);
    });
  };

  const navigationModalInit = () => {
    const modalId = "hoasPrimaryNavigationModal";
    const modalToggleClass = "navigation-open";
    const openButtonsClass = ".open-primary-navigation-button";
    const closeButtonsClass = ".close-navigation";

    const props = {
      modalId: modalId,
      modalToggleClass: modalToggleClass,
      openButtonsClass: openButtonsClass,
      closeButtonsClass: closeButtonsClass,
      closeCallback: () => {
        // After modal is closed --> Custom callback
        superTrap.activate();
        primaryNavigationTrap.deactivate();
        moveCookieBotModal(modalId, false);
      },
      openCallback: () => {
        // After modal is opened --> Custom callback
        primaryNavigationTrap.activate();
        superTrap.deactivate();
        moveCookieBotModal(modalId, true);
        closePrimaryNavigation();
      },
    };

    initialize(props);
  };

  const mobileMenuModalInit = () => {
    const modalId = "hoasMobileModal";
    const modalToggleClass = "menu-open";
    const openButtonsClass = ".open-mobile-menu";

    const props = {
      modalId: modalId,
      modalToggleClass: modalToggleClass,
      openButtonsClass: openButtonsClass,
      closeCallback: () => {
        // After modal is closed --> Custom callback
        mobileModalTrap.deactivate();
        superTrap.activate();
        moveCookieBotModal(modalId, false);
      },
      openCallback: () => {
        // After modal is opened --> Custom callback
        if (!mobileModalTrap.active) {
          mobileModalTrap.activate();
        }
        mobileHeaderFavouritesCounter();
        superTrap.deactivate();
        moveCookieBotModal(modalId, true);

        const modalNavbar = document.querySelector(
          ".mobile-menu-content .navbar-primary",
        );
        initScrollVeil(modalNavbar);
      },
    };

    initialize(props);
  };

  // Define open/close for modal
  const searchModalInit = () => {
    const modalId = "hoasSearchModal";
    const modalToggleClass = "search-modal-open";
    const openButtonsClass = ".header-extra-links--search";
    const closeButtonsClass = ".close-modal-btn";

    const props = {
      modalId: modalId,
      modalToggleClass: modalToggleClass,
      openButtonsClass: openButtonsClass,
      closeButtonsClass: closeButtonsClass,
      closeCallback: () => {
        // After modal is closed --> Custom callback
        let openBtns = $(openButtonsClass);
        openBtns.trigger("focus");
        superTrap.activate();
        searchTrap.deactivate();
        moveCookieBotModal(modalId, false);
      },
      openCallback: () => {
        //Hide aria-label --> 428/426 tickets
        $("#s").attr("aria-label", null);

        //Move necessary dom elements inside trap and remove unnecessary!
        const searchResults = $(".searchwp-live-search-results");
        if (searchResults) {
          const clone = searchResults[0];

          searchResults.each((r) => {
            $(r).remove();
          });
          if (clone) {
            $("#" + modalId).append($(clone));
          }
        }

        // Needs to remove the focus trap (Accessibility), so that the other events will work
        if (!searchTrap.active) {
          searchTrap.activate();
        }
        superTrap.deactivate();
        moveCookieBotModal(modalId, true);
      },
    };

    initialize(props);
  };

  // Back to top button on top of the footer
  backToTopButton.addEventListener("click", () => {
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });

  // Scroll actions.
  const scroll = debounce(() => {
    if (
      window.pageYOffset > headroomOffset &&
      window.pageYOffset < headroomOffset * 2
    ) {
      primaryNavEl.classList.add("before-unpinned");
      if (cookiebotWidget !== null)
        cookiebotWidget.classList.add("before-unpinned");
    } else if (window.pageYOffset > headroomOffset) {
      primaryNavEl.classList.remove("before-unpinned");
      if (cookiebotWidget !== null)
        cookiebotWidget.classList.remove("before-unpinned");
    } else {
      primaryNavEl.classList.remove("before-unpinned");
      if (cookiebotWidget !== null)
        cookiebotWidget.classList.remove("before-unpinned");
    }
  }, 50);

  // Resize screen actions.
  const resize = () => {
    isMobile = ww < mobileMaxWidth;
    // Remove the menu open class, so that the menu won't remain open on resize
    // Match to $hoas-site-navigation-breakpoint
    if (window.innerWidth > 1432) {
      //Navigation is not mobile
      document.body.classList.remove("menu-open");
      document.body.classList.remove("search-modal-open");
      mobileModalTrap.deactivate();

      if ($(".header-extra-links--item.lang").css("display") !== "none") {
        //Language items are not hidden --> Aria-hidden must be false
        $(".header-extra-links--item.lang").attr("aria-hidden", false);
      } else {
        //Language items are hidden --> Aria-hidden must be true
        $(".header-extra-links--item.lang").attr("aria-hidden", true);
      }
    } else {
      //Mobile --> Should be visible to sr!
      $(".header-extra-links--item.lang").attr("aria-hidden", false);
      document.body.classList.remove("modal-open");
      document.body.classList.remove("navigation-open");
      primaryNavigationTrap.deactivate();
    }
  };

  const stickyNav = () => {
    const headroom = new Headroom(primaryNavEl, {
      offset: headroomOffset * 2,
      onPin: function () {
        primaryNavEl.classList.remove("before-unpinned");
      },
    });
    headroom.init();
  };

  // Cookiebot button
  const cookiebotWidgetBtn = () => {
    cookiebotWidget = document.querySelector("#CookiebotWidget");

    const cookiebotWidgetButtons = new Headroom(cookiebotWidget, {
      offset: headroomOffset * 2,
      onPin: function () {
        cookiebotWidget.classList.remove("before-unpinned");
      },
    });
    cookiebotWidgetButtons.init();
  };

  // Check for cookieBot loading
  let checkCB = () => {
    clearTimeout(checkCbTimeout);
    checkCbTimeout = window.setTimeout(function () {
      cookiebotWidget = document.querySelector("#CookiebotWidget");

      if (typeof cookiebotWidget === "undefined" || cookiebotWidget === null) {
        checkCB();
      } else {
        cookiebotWidgetBtn();
      }
    }, 200);
  };
  checkCB();

  /* Functions */
  const handleFirstTab = (e) => {
    // Using tab or enter to move
    if (e.keyCode === 9 || e.keyCode === 13 || e.key === "Shift") {
      document.body.classList.add("user-is-tabbing");
    } else if (e.keyCode !== 9 && e.keyCode !== 13) {
      //Ignore enter and tab otherwise remove the class
      document.body.classList.remove("user-is-tabbing");
    }

    if (e.key === "Tab") {
      if (
        document.body.classList.contains("menu-open") &&
        !mobileModalTrap.active
      ) {
        //Mobilemenu is open!
        mobileModalTrap.activate();
      } else if (
        document.body.classList.contains("search-modal-open") &&
        !searchTrap.activate
      ) {
        searchTrap.activate();
      }

      if (!e.shiftKey && $(e.target).attr("id") === "hoas-giosg-button") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  $(".hoas-giosg-button--extra-button").on("click", function (e) {
    handleGiosgChatInsideModal(e);
  });

  const handleGiosgChatInsideModal = (e) => {
    mobileModalTrap.deactivate();
    superTrap.activate();

    if ($("#hoas-giosg-button")) {
      $("#hoas-giosg-button").trigger("click");
    }

    if ($("#giosg_chat_now_button")) {
      //For staging
      $("#giosg_chat_now_button").trigger("click");
    }

    $("#giosg_live_chat_dialog").css("display", "block");

    let close = $("#giosg_live_chat_dialog").find(
      "button.giosg-chat-dialog-close-button",
    );

    if (close) {
      close.each((btn) => {
        if (btn) {
          btn.on("click", function (e) {
            superTrap.deactivate();
            mobileModalTrap.activate();
          });
          btn.on("keydown", function (e) {
            if (e.key === "Enter") {
              superTrap.deactivate();
              mobileModalTrap.activate();
            }
          });
        }
      });
    }
  };

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  // Exports to DOM binds.
  return { init: init, scroll: scroll, resize: resize };
})();

/*
 *	Check for scrollbar, and add class to body for compensation.
 */
const hoasAppHandleWindow = function () {
  var body = document.querySelector("body"),
    css =
      ":root {--scroll-bar: " +
      (window.innerWidth - body.clientWidth) +
      "px; }",
    head = document.querySelector("head"),
    style = document.createElement("style");

  //Stylesheet
  style.type = "text/css";
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  // Check for scrollbar
  if (window.innerWidth > body.clientWidth + 5) {
    body.classList.add("has-scrollbar");
    head.appendChild(style);
  } else {
    body.classList.remove("has-scrollbar");
  }
};

/**
 * VanillaJS smooth scrolling with an anchor
 */
function addAnchorScrollListeners() {
  // Listen for anchor-scroll to
  document.addEventListener("click", listenLinkClick);
  document.addEventListener("keydown", listenLinkClick);
}

/**
 * Listen click and keydown
 * Scroll to animation if <a> has href with #
 * @param {Event} event
 * @returns {Event}
 */
const listenLinkClick = (event) => {
  if (event.key !== "Click" && event.key !== "Enter") {
    return event;
  }

  const target = event.target;

  if (target.tagName !== "A") {
    return event;
  }

  const href = target.getAttribute("href");

  if (href && href.startsWith("#")) {
    // Clicked element with an anchor
    event.preventDefault();
    scrollToAnimation(href);
  }
  return event;
};

function scrollToAnimation(id) {
  if (!id) {
    return;
  }
  //JQuery counts position relative to document
  const element = $(id);

  if (!element?.length) {
    return;
  }
  const targetOffset = element.offset().top;
  $("html, body").animate({
    scrollTop: targetOffset,
  });
}

/**
 *  DOM listener for Anchors to translate space and enter to click on specified elements
 *  Idea from: https://karlgroves.com/2014/11/24/ridiculously-easy-trick-for-keyboard-accessibility
 */
function assignA11yClick(elementTagName) {
  const A11yElements = document.getElementsByTagName(elementTagName);

  for (let i = 0; i < A11yElements.length; i++) {
    A11yElements[i].addEventListener(
      "keypress",
      function (event) {
        event.preventDefault();
        var code = event.charCode || event.keyCode;
        // Space or Enter
        if (code === 32 || code === 13) {
          this.click();
        }
      },
      false,
    );
  }
}

/**
 * Area listing page filtering
 */
function area_list_filter_action() {
  const isAreaPage = document.querySelector(
    "body.page-template-page-area-listing",
  );

  // Early exit if wrong template
  if (!isAreaPage) {
    return;
  }

  // URL Params
  const { protocol, host, pathname, search } = window.location;
  const fullUrlWithoutParams = `${protocol}//${host}${pathname}`;
  const urlParams = new URLSearchParams(search);

  const paramName = "city";
  const cityParam = urlParams.get(paramName);
  const hasCityParam = urlParams.has(paramName);
  const slideToID = "#area-list";

  // Grid
  const grid = document.querySelector(".area-suggestions--grid");

  // Is there a grid to work with?
  if (!grid) {
    return;
  }

  // Elements and classes
  let doAfterReziseTimeout;
  let activeClass = "active";
  let buttonClass = ".filter-button";
  let iso = new Isotope(grid, {
    itemSelector: ".area-suggestions--item",
    layoutMode: "fitRows",
  });
  let filtersElems = document.querySelectorAll(".area-filter--buttons");

  // bind button Click function to filters
  for (let i = 0; i < filtersElems.length; ++i) {
    filtersElems[i].addEventListener("click", function (event) {
      event.preventDefault();
      filterClickFunction(event);
    }); //.END click
    filtersElems[i].addEventListener("keydown", function (event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        filterClickFunction(event);
      }
    }); //.END keydown
  }

  // Click function
  function filterClickFunction(event) {
    let thisButton = event.target;
    let filterButtons = document.querySelectorAll(buttonClass);

    // Deactivate buttons
    filterButtons.forEach((button, index) => {
      button.classList.remove(activeClass);
    });

    // Set this btn active
    thisButton.classList.add(activeClass);

    // Do Isotope filtering magic
    let filterValue = event.target.getAttribute("data-filter");
    iso.arrange({ filter: filterValue });

    const speakerMessage = thisButton.getAttribute("aria-label");
    announceMessage(globalAccessibilitySpeakerId, speakerMessage);

    // Change the url parameter according to the selected filter
    if (filterValue === "*") {
      window.history.replaceState(
        {},
        document.title,
        fullUrlWithoutParams + "?" + paramName + "=" + "all",
      );
    } else {
      window.history.replaceState(
        {},
        document.title,
        fullUrlWithoutParams + "?" + paramName + "=" + filterValue.slice(1),
      ); // Remove the dot in the filter
    }
  }

  // Check if there's a city param in the Url, and simulate click to filter the cities
  if (hasCityParam) {
    let targetButton = document.querySelectorAll(
      "[data-target=" + cityParam + "]",
    );
    if (targetButton.length > 0) {
      // Just click the first in array. Shouldn't be more, and if is, shouldn't be relevant.
      targetButton[0].click();
      // Slide to the section
      scrollToAnimation(slideToID);
    }
  }

  window.addEventListener(
    "resize",
    function (evt) {
      doAfterReziseTimeout = window.setTimeout(function () {
        doAfterRezise();
      }, 300);
    },
    { passive: true },
  );

  function doAfterRezise() {
    window.clearTimeout(doAfterReziseTimeout);
    iso.arrange();
  }
}

/**
 * DOM listener binds
 * --> Init
 * --> Scroll
 * --> Resize
 */
document.addEventListener("DOMContentLoaded", () => {
  hoasApp.init();
  hoasAppHandleWindow();
  addAnchorScrollListeners();
  // Add space/enter listening on A tags
  assignA11yClick("a");
  area_list_filter_action();
});

window.addEventListener(
  "scroll",
  () => {
    hoasApp.scroll();
  },
  { passive: true },
);

window.addEventListener(
  "resize",
  () => {
    hoasApp.resize();
    hoasAppHandleWindow();
  },
  { passive: true },
);

// Focus on an element by id
window.setFocusTo = (target, focusEl, scroll, event) => {
  event.preventDefault();

  // If String given
  if (typeof target === "string") {
    let targetEl = "";

    // If id
    if (target.indexOf("#") === 0) {
      let targetID = target.substring(target.indexOf("#") + 1); // get id after hash
      // use getElementById, because it's faster. Could have just used querySelector for all.
      targetEl = document.getElementById(targetID);
    } else if (target.indexOf(".") === 0) {
      // if class / classes
      targetEl = document.querySelector(target);
      // Add tabindex to make sure it can be focused on
    } else {
      // Treat as ID by default
      targetEl = document.getElementById(target);
    }

    // Goto Element and focus
    if (typeof scroll !== "undefined" && scroll) {
      scrollToAnimation(target);
    }

    // Focus
    if (focusEl) {
      // Setup for focus
      focusEl = document.querySelector(focusEl);
      focusEl.setAttribute("tabindex", "-1");
      focusEl.focus();
    } else {
      // Setup for focus
      targetEl.setAttribute("tabindex", "-1");
      targetEl.focus();
    }
  }
  // If document element passed
  else {
    target.focus();
  }
};

//https://css-tricks.com/snippets/javascript/loop-queryselectorall-matches/
const forEach = function (array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]); // passes back stuff we need
  }
};
